<mat-card appearance="outlined">
    @if(loading$ | async){
        <div class="d-flex justify-content-center m-t-1 m-b-1">
            <mat-spinner></mat-spinner>
        </div>
    }
    @else{
  <mat-card-content> 
    @if(message) {
        <div class="m-b-05">{{message.timeSent | dateTimeFromIso | dateTimeToFormat: 'MMM dd, yyyy, HH:mm' }} <br></div>
        @if(!message.fromClient){
        <div class="m-b-05">Sent from {{message.staffName }}<br></div>
        }
        @else{
           <div class="m-b-05">Sent to MM<br></div> 
        }
        <div class="m-b-05 bold">{{message.subject}}<br></div>
        <mat-divider></mat-divider>

        @if (message.onlineQuestionnaireId) {
            <div class="m-t-1">
                @if(!isQuestionnaireDeleted() && !isQuestionnaireExpired()){
                <a mat-flat-button [href]="" class="m-b-1" (click)="OpenQuestionnaire(message.onlineQuestionnaireId)">Open Questionnaire</a>
                }
                @else {
                    @if(isQuestionnaireDeleted()){
                        <div class="mat-error m-b-1">Questionnaire Closed</div>
                    }
                    @if(isQuestionnaireExpired()){
                        <div class="mat-error m-b-1">This link has expired, please contact your migration agent for more details.</div>
                    }
                }
                <mat-divider></mat-divider>
            </div>
        }

        @if (messageAttachments) {
            @for (messageAttachment of messageAttachments; track id) {
                <div class="m-t-1">
                    <div class="d-flex justify-content-sb m-b-1">
                        <div><mat-icon class="file-icon">{{getFileIcon(messageAttachment)}}</mat-icon></div>
                        <div class="flex-1 m-l-05">
                            @if (attachmentNotExpired(messageAttachment) ) {
                                <div><a class="link-button" [ngClass]="messageAttachment.timeDownloaded ? '' : 'bold'" (click)="downloadAttachment(messageAttachment.id)">{{messageAttachment.fileName}}</a><br></div>
                            } @else {
                                <div [ngClass]="messageAttachment.timeDownloaded ? '' : 'bold'" (click)="downloadAttachment(messageAttachment.id)">{{messageAttachment.fileName}}<br></div>
                            }
                            <div *ngIf="messageAttachment.expiresDateTime" [ngClass]="attachmentNotExpired(messageAttachment) ? '' : 'expired'">{{attachmentNotExpired(messageAttachment) ? 'Expires' : 'Expired'}} {{messageAttachment.expiresDateTime | dateTimeFromIso | dateTimeToFormat: 'MMM dd, yyyy'}}</div>
                            <div *ngIf="messageAttachment.hash"><app-hidden-copy-display [value]="messageAttachment.hash" textDescription="Hash"></app-hidden-copy-display></div>
                        </div>
                        <button mat-button mat-stroked-button (click)="downloadAttachment(messageAttachment.id)" *ngIf="attachmentNotExpired(messageAttachment)"><mat-icon>download</mat-icon> Download</button>
                    </div>
                </div>
            }
            <mat-divider></mat-divider>
        }
        
        <div class="message-content" [innerHTML]="message.body"></div>        
        <hr/>

        <div class="d-flex justify-content-sb m-t-1 no-print">
            <div>
                <button mat-button mat-stroked-button (click)="printMessage()"><mat-icon>print</mat-icon> Print</button>
            </div>
            <div>
                @if(!message.fromClient){
                <a mat-flat-button [routerLink]="getReplyMessageRouterLink()"><mat-icon>reply</mat-icon> Reply</a>
                }
                <a mat-button mat-stroked-button (click)="onClose()" class="m-l-05">Close</a>
            </div>
        </div>
    }

  </mat-card-content>
}
</mat-card>
